"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const monaco = __importStar(require("monaco-editor"));
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
require("requestidlecallback");
const Button_1 = require("./Button");
const Card_1 = require("./Card");
require("./completion");
const monaco_cut_line_1 = require("./monaco-cut-line");
const monaco_flexible_1 = require("./monaco-flexible");
const monaco_line_alter_1 = require("./monaco-line-alter");
const monaco_suggest_button_1 = require("./monaco-suggest-button");
const store_1 = require("./store");
const element_scss_1 = __importDefault(require("./styles/element.scss"));
const flex_scss_1 = __importDefault(require("./styles/flex.scss"));
function CodeCell({ id, value, title, onUpdate }) {
    const dispatch = react_redux_1.useDispatch();
    const rootRef = React.useRef(null);
    const editorRef = React.useRef();
    const [floating, setFloating] = React.useState(false);
    const [undoable, setUndoable] = React.useState(false);
    React.useEffect(() => {
        if (!rootRef.current)
            return;
        const editor = monaco.editor.create(rootRef.current, {
            value,
            language: 'coffeescript',
            minimap: { enabled: false },
            lineNumbersMinChars: 3,
            folding: false,
            scrollbar: {
                horizontal: 'hidden',
                vertical: 'hidden'
            },
            renderWhitespace: 'all'
        });
        if (process.env.NODE_ENV !== 'production') {
            editor.updateOptions({
                contextmenu: false
            });
        }
        const model = editor.getModel();
        model &&
            model.updateOptions({
                insertSpaces: true,
                tabSize: 2,
                trimAutoWhitespace: false
            });
        editorRef.current = editor;
        monaco_flexible_1.beFlexible(editor);
        monaco_line_alter_1.showLineAlter(editor);
        monaco_suggest_button_1.showSuggestButtons(editor);
        monaco_cut_line_1.showCutLine(editor);
        editor.onDidFocusEditorText(() => {
            setFloating(true);
            dispatch(store_1.actions.bringGameFront(false));
        });
        editor.onDidBlurEditorText(() => {
            setFloating(false);
            dispatch(store_1.actions.bringGameFront(true));
        });
        let replTimerId = 0;
        editor.onDidChangeModelContent(() => {
            window.clearTimeout(replTimerId);
            replTimerId = window.setTimeout(() => {
                onUpdate({ id, value: editor.getValue() });
            }, 250);
        });
        editor.onDidChangeModelContent(() => {
            if (model) {
                setUndoable(model.getAlternativeVersionId() > 1);
            }
        });
        return () => {
            editor.dispose();
        };
    }, []);
    const undo = React.useCallback(() => {
        if (!editorRef.current)
            return;
        editorRef.current.trigger('', 'undo', {});
    }, []);
    return (React.createElement(Card_1.Card, { elevated: floating, className: element_scss_1.default.codeCell },
        React.createElement("div", { className: classnames_1.default(flex_scss_1.default.horizontal, element_scss_1.default.codeCellHeader) },
            React.createElement("span", null, title || 'NO TITLE'),
            React.createElement("div", { className: flex_scss_1.default.blank }),
            React.createElement(Button_1.IconButton, { name: "clear", tooltip: "Remove this cell" })),
        React.createElement(Card_1.CardDivider, null),
        React.createElement("div", { ref: rootRef, className: element_scss_1.default.codeCellEditor, style: { height: monaco_flexible_1.getInitialHeight(value) } }),
        React.createElement(Card_1.CardDivider, null),
        React.createElement("div", { className: classnames_1.default(flex_scss_1.default.horizontal, element_scss_1.default.codeCellFooter) },
            React.createElement(Button_1.IconButton, { name: "undo", disabled: !undoable, onClick: undo }, "Undo"),
            React.createElement("div", { className: flex_scss_1.default.blank }),
            React.createElement(Button_1.IconButton, { name: "note_add", primary: true, tooltip: "Create new cell" }),
            React.createElement(Button_1.IconButton, { name: "file_copy", primary: true, tooltip: "Copy this cell" }),
            React.createElement(Button_1.IconButton, { name: "arrow_upward", primary: true, tooltip: "Move up" }),
            React.createElement(Button_1.IconButton, { name: "arrow_downward", primary: true, tooltip: "Move down" }))));
}
exports.CodeCell = CodeCell;
